var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLI4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.609,
    height: 40,
    viewBox: "0 0 35.609 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_128579",
    "data-name": "Group 128579",
    transform: "translate(-18018.391 -3026.712)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_6011",
    "data-name": "Rectangle 6011",
    d: "M2.945-.75H31.164a3.7,3.7,0,0,1,3.7,3.7v32.61a3.7,3.7,0,0,1-3.7,3.7H2.945a3.7,3.7,0,0,1-3.7-3.7V2.945A3.7,3.7,0,0,1,2.945-.75ZM31.164,37.335a1.782,1.782,0,0,0,1.78-1.78V2.945a1.782,1.782,0,0,0-1.78-1.78H2.945a1.782,1.782,0,0,0-1.78,1.78v32.61a1.782,1.782,0,0,0,1.78,1.78Z",
    transform: "translate(18019.141 3027.462)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91151",
    "data-name": "Path 91151",
    d: "M94.164,79.036c3.323,4.3,8.655,4.848,10.729,4.888A20.075,20.075,0,0,1,94.015,101.4c-10.48-5.6-10.837-14.711-10.707-17.328,2.033-.059,7.452-.644,10.856-5.031m0-1.915a1.912,1.912,0,0,0-1.513.742c-2.879,3.711-7.531,4.236-9.4,4.289a1.916,1.916,0,0,0-1.858,1.82c-.146,2.937.267,13,11.717,19.113a1.912,1.912,0,0,0,1.813-.005,21.987,21.987,0,0,0,11.883-19.135,1.916,1.916,0,0,0-1.878-1.936c-1.846-.036-6.446-.511-9.25-4.144a1.916,1.916,0,0,0-1.513-.744Z",
    transform: "translate(17942.104 2956.498)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91152",
    "data-name": "Path 91152",
    d: "M91.349,93.654,87.195,89.5a.958.958,0,0,1,1.354-1.354l2.8,2.8,6.126-6.125a.958.958,0,1,1,1.354,1.354Z",
    transform: "translate(17943.637 2958.552)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLI4);
export default __webpack_public_path__ + "static/media/l-i-4.03554620d704760dc0219e55b1f2680e.svg";
export { ForwardRef as ReactComponent };